module.exports = __webpack_public_path__ + "img/luza2.7c1baeaa.png";